import React, { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "./mainLanding.scss";
import screenshot from "./resources/Screenshot.png";
import appNote_Ellipsometer from "./resources/Image_AppNoteEllipsometer.png";
import box from "./resources/placeholder.png";
import { useNavigate } from "react-router-dom";
import LandingHeader from "./LandingHeader";
import LandingFooter from "./LandingFooter";

const MainLanding = () => {
  const navigate = useNavigate();

  // Scroll to top when the component mounts
  useEffect(() => {
    window.location.replace("https://www.speqqle.com/");
    // window.scrollTo(0, 0);
  }, []);

  return (
    // Add an id here for higher specificity in your SCSS
    <div id="mainLanding" className="mainLandingContainer">
      <div className="container py-5">
        {/* Navigation */}
        <LandingHeader />

        <div className="row g-3 extra-large-space"></div>

        {/* Main Heading */}
        <div className="text-center mb-3">
          <h1 className="fw-bold text-black display-5">
            Fit all your spectroscopy experiments to get the information you
            need from your data
          </h1>
        </div>

        <div className="row g-3 extra-large-space"></div>

        {/* Screenshot */}
        <div className="text-center mb-5">
          <img
            src={screenshot}
            alt="Screenshot"
            className="img-fluid"
            style={{ width: "60%", height: "auto" }}
          />
        </div>

        {/* Call-to-Action Button */}
        <div className="text-center mb-5">
          <button
            className="btn btn-lg fw-bold text-white"
            style={{
              backgroundColor: "rgb(228, 108, 10)",
              borderRadius: "10px",
            }}
            onClick={() => navigate("/login")}
          >
            Try it out now!
          </button>
        </div>

        <div className="row g-3 extra-large-space"></div>
        <div className="row g-3 extra-large-space"></div>
        <div className="row g-3 extra-large-space"></div>

        {/* How app.speqqle simplifies spectroscopic analysis */}
        <div className="text-center mt-5">
          <h3 className="fw-bold" style={{ color: "rgb(0, 0, 0)" }}>
            How{" "}
            <span className="fw-bold" style={{ color: "rgb(31, 73, 125)" }}>
              app.speqqle
            </span>{" "}
            will simplify your spectroscopic analysis
          </h3>
          <p className="text-secondary">
            Do you need to analyse one or more spectroscopic experiments? The
            easiest way to do this is app.speqqle.
          </p>
        </div>

        <div className="row g-3 extra-large-space"></div>

        {/* Features */}
        <div className="row g-3">
          <div className="col-md-4">
            <div className="p-3 rounded text-center">
              <h5 className="fw-bold" style={{ color: "rgb(31, 73, 125)" }}>
                For users of all optical spectroscopies
              </h5>
              <p className="text-secondary">
                Includes reflectivity, transmission, ellipsometry, Raman, SNOM
                and many more on bulk, multilayer or gas samples
              </p>
            </div>
          </div>
          <div className="col-md-4">
            <div className="p-3 rounded text-center">
              <h5 className="fw-bold" style={{ color: "rgb(31, 73, 125)" }}>
                For non-scientists and spectroscopy experts
              </h5>
              <p className="text-secondary">
                Intuitive interface and access to tutorials, FAQs and support to
                guide you in your analysis
              </p>
            </div>
          </div>
          <div className="col-md-4">
            <div className="p-3 rounded text-center">
              <h5 className="fw-bold" style={{ color: "rgb(31, 73, 125)" }}>
                Get complex material properties in an easy way
              </h5>
              <p className="text-secondary">
                Extract the refractive index and dielectric constant of iso- or
                anisotropic samples
              </p>
            </div>
          </div>
          <div className="col-md-4">
            <div className="p-3 rounded text-center">
              <h5 className="fw-bold" style={{ color: "rgb(31, 73, 125)" }}>
                Tested by scientists
              </h5>
              <p className="text-secondary">
                The analysis of optical spectra is based on the RefFIT package
                developed and tested at the University of Geneva since 2005
              </p>
            </div>
          </div>
          <div className="col-md-4">
            <div className="p-3 rounded text-center">
              <h5 className="fw-bold" style={{ color: "rgb(31, 73, 125)" }}>
                Time saver for your project
              </h5>
              <p className="text-secondary">
                Analysis does not require any coding knowledge or a team of
                scientists
              </p>
            </div>
          </div>
          <div className="col-md-4">
            <div className="p-3 rounded text-center">
              <h5 className="fw-bold" style={{ color: "rgb(31, 73, 125)" }}>
                Simultaneous fitting of different data sets
              </h5>
              <p className="text-secondary">
                Enhance the precision by fitting data from different optical
                spectroscopies
              </p>
            </div>
          </div>
        </div>

        <div className="row g-3 extra-large-space"></div>
        <div className="row g-3 extra-large-space"></div>

        {/* How app.speqqle works */}
        <div className="text-center mt-5">
          <h3 className="fw-bold" style={{ color: "rgb(0, 0, 0)" }}>
            How{" "}
            <span className="fw-bold" style={{ color: "rgb(31, 73, 125)" }}>
              app.speqqle
            </span>{" "}
            works
          </h3>
          <p className="text-secondary">
            Your data is fitted to physical models developed and tested by
            scientists. You choose the model based on your experiment, i.e., the
            type of spectroscopy and your sample properties. app.speqqle fits
            your data without any need for you to code, so that you can directly
            access the output parameters that interest you.
          </p>
        </div>

        <div className="row g-3 extra-large-space"></div>

        {/* Comparison Boxes */}
        <div className="row g-3 mt-20">
          <div className="col-md-4 d-flex">
            <div className="box box-light-gray w-100">
              <h5 className="fw-bold">Your Experiment</h5>
              <div className="text-content">
                <p>
                  <strong>Spectroscopy type</strong>
                  <br />
                  Raman
                  <br />
                  Transmission
                  <br />
                  Ellipsometry
                  <br />
                  and many more....
                  <br />
                  <br />
                  <strong>Sample</strong>
                  <br />
                  bulk/multilayer/gas
                  <br />
                  anisotropy
                  <br />
                </p>
              </div>
            </div>
          </div>
          <div className="col-md-4 d-flex">
            <div className="box box-light-blue w-100">
              <h5 className="fw-bold">app.speqqle</h5>
              <div className="text-content">
                <p>
                  <strong>Scientific model</strong>
                  <br />
                  Developed and tested by scientists
                  <br />
                  <br />
                  <br />
                  <strong>Fitting algorithm</strong>
                  <br />
                  Optimized fast Levenberg-Marquard algorithm
                  <br />
                </p>
              </div>
            </div>
          </div>
          <div className="col-md-4 d-flex">
            <div className="box box-light-green w-100">
              <h5 className="fw-bold">Output</h5>
              <div className="text-content">
                <p>
                  Refractive index
                  <br />
                  Complex dielectric constant
                  <br />
                  Layer thickness
                  <br />
                  Stoichiometry
                  <br />
                  Temperature
                  <br />
                  Concentration
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="row g-3 extra-large-space"></div>
        <div className="row g-3 extra-large-space"></div>
        <div className="row g-3 extra-large-space"></div>

        {/* Applications Section */}
        <h2 className="fw-bold text-black text-center mb-4">Applications</h2>
        <div className="text-center mt-2">
          <h5 className="fw-bold" style={{ color: "rgb(31, 73, 125)" }}>
            <span className="fw-bold" style={{ color: "rgb(0, 0, 0)" }}></span>
          </h5>
          <p className="text-secondary">
            Whether you want to determine the refractive index of your material
            or the thickness of a film, app.speqqle has a lot of applications
            you can find out more about here.
          </p>
        </div>

        <div className="row g-3 extra-large-space"></div>

        {/* Carousel */}
        <div
          id="exampleCarousel"
          className="carousel slide"
          data-bs-ride="carousel"
        >
          <div className="carousel-inner">
            <div className="carousel-item active">
              <div className="row">
                <div className="col-md-4">
                  <div className="example-box">
                    <h5>Ellipsometry</h5>
                    <p>
                      Analysis of ellipsometry data to determine the complex
                      dielectric constant and refractive index of bulk tungsten
                      carbide
                    </p>
                    <img
                      src={appNote_Ellipsometer}
                      alt="Box 1"
                      className="img-fluid"
                    />
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="example-box">
                    <h5>New application</h5>
                    <p>
                      Coming
                      <br />
                      soon
                      <br />
                      to app.speqqle
                    </p>
                    <img src={box} alt="Box 2" className="img-fluid" />
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="example-box">
                    <h5>New application</h5>
                    <p>
                      Coming
                      <br />
                      soon
                      <br />
                      to app.speqqle
                    </p>
                    <img src={box} alt="Box 3" className="img-fluid" />
                  </div>
                </div>
              </div>
            </div>
            <div className="carousel-item">
              <div className="row">
                <div className="col-md-4">
                  <div className="example-box">
                    <h5>New application</h5>
                    <p>
                      Coming
                      <br />
                      soon
                      <br />
                      to app.speqqle
                    </p>
                    <img src={box} alt="Box 4" className="img-fluid" />
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="example-box">
                    <h5>New application</h5>
                    <p>
                      Coming
                      <br />
                      soon
                      <br />
                      to app.speqqle
                    </p>
                    <img src={box} alt="Box 5" className="img-fluid" />
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="example-box">
                    <h5>New application</h5>
                    <p>
                      Coming
                      <br />
                      soon
                      <br />
                      to app.speqqle
                    </p>
                    <img src={box} alt="Box 6" className="img-fluid" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <button
            className="carousel-control-prev"
            type="button"
            data-bs-target="#exampleCarousel"
            data-bs-slide="prev"
          >
            <span
              className="carousel-control-prev-icon"
              aria-hidden="true"
            ></span>
            <span className="visually-hidden">Previous</span>
          </button>
          <button
            className="carousel-control-next"
            type="button"
            data-bs-target="#exampleCarousel"
            data-bs-slide="next"
          >
            <span
              className="carousel-control-next-icon"
              aria-hidden="true"
            ></span>
            <span className="visually-hidden">Next</span>
          </button>
        </div>

        <div className="row g-3 extra-large-space"></div>
        <div className="row g-3 extra-large-space"></div>
      </div>
      {/* Footer */}
      <LandingFooter />
    </div>
  );
};

export default MainLanding;
